export enum FileUploadOption {
    Required = 'Required',
    Optional = 'Optional',
    No = 'No'
}
